// extracted by mini-css-extract-plugin
export default {"drawer":"ApplicantNavigator_drawer__nvG86"};